import { render, staticRenderFns } from "./FilesGrid.vue?vue&type=template&id=9ef5f48c&"
import script from "./FilesGrid.vue?vue&type=script&lang=js&"
export * from "./FilesGrid.vue?vue&type=script&lang=js&"
import style0 from "./FilesGrid.vue?vue&type=style&index=0&id=9ef5f48c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports